import { Check } from "lucide-react";

const textOn = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return "#0f172a";
  const n = parseInt(m[1], 16);
  const l = (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  return l > 0.6 ? "#0f172a" : "#ffffff";
};

export function ColorSwatchGrid({ colors = [], selected, onSelect, prefix = "swatch", size = "md" }) {
  const h = size === "sm" ? "h-11" : "h-14";
  return (
    <div className={`grid gap-1.5 ${size === "sm" ? "grid-cols-3 sm:grid-cols-5" : "grid-cols-3 sm:grid-cols-4 md:grid-cols-6"}`} data-testid={`${prefix}-grid`}>
      {colors.map((c, i) => {
        const on = selected === c.name || selected === i;
        return (
          <button key={`${c.name}-${i}`} type="button" onClick={() => onSelect?.(c, i)} title={[c.name, c.pantone && `PMS ${c.pantone}`, c.max_size && `up to ${c.max_size}`].filter(Boolean).join(" · ")}
            data-testid={`${prefix}-${i}`} style={{ background: c.hex || "#fff", color: textOn(c.hex) }}
            className={`relative ${h} rounded-md border text-left px-1.5 py-1 text-[11px] leading-tight font-medium transition-transform hover:-translate-y-0.5 ${on ? "ring-2 ring-[#2495D3] ring-offset-1 border-transparent" : "border-slate-300"}`}>
            <span className="line-clamp-2">{c.name || "Unnamed"}</span>
            {c.max_size && <span className="absolute bottom-0.5 right-1 text-[9px] opacity-80">≤{c.max_size}</span>}
            {on && <Check size={13} className="absolute top-1 right-1" />}
          </button>
        );
      })}
    </div>
  );
}
